function constructQueryString(params: { [key: string]: any}): string {
  return Object.entries(params)
    .filter( ([_, val]) => val != null )
    .map( ([key, val]) => `${encodeURIComponent(key)}=${encodeURIComponent(val)}`)
    .join("&");
}

export default constructQueryString;
